module.exports = __webpack_public_path__ + "img/poster.990a45c6.png";